import React from 'react'
import { Container, Row, Col, Nav, Tab } from "react-bootstrap";
import { FaReact, FaAngular, FaCss3, FaHtml5, FaVuejs, FaNode, FaAws, FaDocker, FaBug } from "react-icons/fa";
import { RiTailwindCssFill } from "react-icons/ri";
import { IoLogoJavascript, IoSettingsOutline, IoLogoFirebase } from "react-icons/io5";
import { SiRubyonrails } from "react-icons/si";
import { AiOutlineDotNet } from "react-icons/ai";
import { VscAzure } from "react-icons/vsc";
import { SiMongodb, SiMysql, SiPostgresql, SiSelenium, SiApachejmeter } from "react-icons/si";
import { PiMaskHappyFill } from "react-icons/pi";


export default function TechBlock() {
    return (
        <section className="padding-section-large contact-section">
            <Container className="">
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3"><span className="text-gradient-1">Technologies</span> We Work With</h2>
                        <h5 className='heading-style-h5 pb-5'> A well-rounded stack to develop, expand and maintain dependable software.</h5>
                    </Col>
                </Row>

                <Tab.Container defaultActiveKey="frontend">
                    <Row>

                        {/* LEFT SIDE TABS */}
                        <Col md={3}>
                            <Nav className="flex-column tech-tabs">
                                <Nav.Link eventKey="frontend">Frontend</Nav.Link>
                                <Nav.Link eventKey="backend">Backend</Nav.Link>
                                <Nav.Link eventKey="mobile">Mobile</Nav.Link>
                                <Nav.Link eventKey="cloud">Cloud & DevOps</Nav.Link>
                                <Nav.Link eventKey="database">Database</Nav.Link>
                                <Nav.Link eventKey="qa">Quality & Testing</Nav.Link>
                            </Nav>
                        </Col>

                        {/* RIGHT CONTENT */}
                        <Col md={9}>
                            <Tab.Content>

                                {/* Frontend */}
                                <Tab.Pane eventKey="frontend">
                                    <h5 className="mb-3">Frontend</h5>
                                    <div className="tech-grid">
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><FaReact style={{ color: "#62dafc" }} /></div>
                                            <p>React</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><FaAngular style={{ color: "#dd0031" }} /></div>
                                            <p>Angular</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><FaCss3 style={{ color: "#264de4" }} /></div>
                                            <p>CSS3</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><FaHtml5 style={{ color: "#e75727" }} /></div>
                                            <p>HTML5</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><RiTailwindCssFill style={{ color: "#38bdf8" }} /></div>
                                            <p>Tailwind</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><IoLogoJavascript style={{ color: "#f7df1e" }} /></div>
                                            <p>JavaScript</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><FaVuejs style={{ color: "#41b883" }} /></div>
                                            <p>VueJS</p>
                                        </div>
                                    </div>
                                </Tab.Pane>

                                {/* Backend */}
                                <Tab.Pane eventKey="backend">
                                    <h5 className="mb-3">Backend</h5>
                                    <div className="tech-grid">
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><SiRubyonrails style={{ color: "#cc0000" }} /></div>
                                            <p>Ruby on Rails</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><FaNode style={{ color: "#73aa62" }} /></div>
                                            <p>Node js</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><AiOutlineDotNet style={{ color: "#512bd4" }} /></div>
                                            <p>.Net</p>
                                        </div>
                                    </div>
                                </Tab.Pane>

                                {/* cloud & devops */}
                                <Tab.Pane eventKey="cloud">
                                    <h5 className="mb-3">Cloud & Devops</h5>
                                    <div className="tech-grid">
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><FaAws style={{ color: "#FF9900" }} /></div>
                                            <p>AWS</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><VscAzure style={{ color: "#008AD7" }} /></div>
                                            <p>Azure</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><FaDocker style={{ color: "#0db7ed" }} /></div>
                                            <p>Docker</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><IoSettingsOutline style={{ color: "#326CE5" }} /></div>
                                            <p>CI/CD</p>
                                        </div>
                                    </div>
                                </Tab.Pane>

                                {/*databases */}
                                <Tab.Pane eventKey="database">
                                    <h5 className="mb-3">Databases</h5>
                                    <div className="tech-grid">
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><SiPostgresql style={{ color: "#336791" }} /></div>
                                            <p>PostgreSQL</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><SiMysql style={{ color: "#00758F" }} /></div>
                                            <p>MySQL</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><SiMongodb style={{ color: "#3FA037" }} /></div>
                                            <p>MongoDB</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><IoLogoFirebase style={{ color: "#FF9100" }} /></div>
                                            <p>Firebase Cloud</p>
                                        </div>
                                    </div>
                                </Tab.Pane>

                                {/*Quality & Testing */}
                                <Tab.Pane eventKey="qa">
                                    <h5 className="mb-3">Quality & Testing</h5>
                                    <div className="tech-grid">
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><SiSelenium style={{ color: "#5EBB49" }} /></div>
                                            <p>Selenium</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><SiApachejmeter style={{ color: "#D22128" }} /></div>
                                            <p>JMeter</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><PiMaskHappyFill style={{ color: "#E2574C" }} /></div>
                                            <p>Playwright</p>
                                        </div>
                                        <div className="tech-card p-3 text-center">
                                            <div className="icon-box"><FaBug style={{ color: "#FF9100" }} /></div>
                                            <p>Manual & Automation</p>
                                        </div>
                                    </div>
                                </Tab.Pane>

                            </Tab.Content>
                        </Col>

                    </Row>
                </Tab.Container>

            </Container>
        </section>
    )
}
